var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cdn-tabs",on:{"click":_vm.clickParent}},_vm._l((_vm.tabs),function(items,index){return _c('div',{key:index,staticClass:"tabs-item selected"},[_vm._v(_vm._s(items))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }